import {Title} from '@app/titles/models/title';
import {SiteSectionHeading} from '@app/titles/site-section-heading';
import {Trans} from '@common/i18n/trans';
import {useRelatedTitles} from '@app/titles/requests/use-related-titles';
import {useCarousel} from '@app/channels/carousel/use-carousel';
import React, {Fragment, useRef} from 'react';
import {IconButton} from '@common/ui/buttons/icon-button';
import {KeyboardArrowLeftIcon} from '@common/icons/material/KeyboardArrowLeft';
import {KeyboardArrowRightIcon} from '@common/icons/material/KeyboardArrowRight';
import clsx from 'clsx';
import {TitlePortraitGridItem} from '@app/channels/content-grid/title-grid-item';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom'; // Swiper
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation} from 'swiper/modules';
import {useThemeSelector} from '@common/ui/themes/theme-selector-context';

const modules = [Autoplay, Navigation];

interface Props {
  title: Title;
}
export function RelatedTitlesPanel({title}: Props) {
  const {data} = useRelatedTitles(title.id);

  if (!data || data.titles?.length === 0) {
    return null;
  }

  return <RelatedTitlesCarousel titles={data.titles} />;
}

interface RelatedTitlesCarouselProps {
  titles: Title[];
}
function RelatedTitlesCarousel({titles}: RelatedTitlesCarouselProps) {
  const {
    scrollContainerRef,
    canScrollForward,
    canScrollBackward,
    scrollToPreviousPage,
    scrollToNextPage,
    containerClassName,
    itemClassName,
  } = useCarousel();

  const slider = useRef<HTMLDivElement>(null);
  const {selectedTheme} = useThemeSelector();

  const initSwiper = (swiper: any) => {
    addCustomClassToVisibleSlides(swiper);
  };

  const addCustomClassToVisibleSlides = (swiper: any) => {
    if (slider.current) {
      if (swiper) {
        slider.current
          .querySelectorAll('.swiper-slide')
          .forEach(separateSlide => separateSlide.classList.remove('last'));

        const swiperSlide = slider.current.querySelectorAll(
          '.swiper-slide-visible',
        );

        const lastVisibleSlide = swiperSlide[swiperSlide.length - 1];

        setTimeout(() => {
          if (lastVisibleSlide) {
            lastVisibleSlide.classList.add('swiper-active', 'last');
          }
        }, 0);
      }
    }
  };

  return (
    <div className="-mx-20 mt-48 md:-mx-86">
      {' '}
      <div className="card-style-slider overflow-hidden">
        <Container fluid>
          <div className={`card-style-slider overflow-hidden`} ref={slider}>
            <div
              className={`d-flex align-items-center justify-content-between px-md-3 mb-4 px-1`}
            >
              <h4
                className={`main-title text-capitalize mb-0 ${!selectedTheme.is_dark && 'text-black'}`}
              >
                <Trans message="More like this" />
              </h4>
            </div>
            <Swiper
              className={`swiper swiper-card swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress swiper-backface-hidden position-relative undefined`}
              slidesPerView={6}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 4,
                },
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 4,
                },
                1500: {
                  slidesPerView: 6,
                  spaceBetween: 4,
                },
              }}
              loop
              watchSlidesProgress
              navigation={{
                prevEl: '.swiper-banner-button-prev',
                nextEl: '.swiper-banner-button-next',
              }}
              onSwiper={initSwiper}
              onSlideChange={initSwiper}
              modules={modules}
            >
              {titles.map((item, index) => (
                <SwiperSlide
                  tag="li"
                  className="!mr-0 !pr-0"
                  key={index + generateUUID() + 'slider'}
                >
                  <TitlePortraitGridItem item={item} />
                </SwiperSlide>
              ))}
              <div
                className="swiper-banner-button-prev swiper-nav hidden md:block"
                id="swiper-banner-button-prev"
              >
                <i></i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 44 44"
                  width="44"
                  height="44"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle r="20" cy="22" cx="22"></circle>
                </svg>
              </div>
              <div
                className="swiper-banner-button-next swiper-nav hidden md:block"
                id="swiper-banner-button-next"
              >
                <i></i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 44 44"
                  width="44"
                  height="44"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle r="20" cy="22" cx="22"></circle>
                </svg>
              </div>
            </Swiper>
          </div>
        </Container>
      </div>
      {/* <SiteSectionHeading
        actions={
          <Fragment>
            <IconButton
              disabled={!canScrollBackward}
              onClick={() => scrollToPreviousPage()}
              aria-label="Scroll left"
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
            <IconButton
              disabled={!canScrollForward}
              onClick={() => scrollToNextPage()}
              aria-label="Scroll right"
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          </Fragment>
        }
      >
        <Trans message="More like this" />
      </SiteSectionHeading> */}
      {/* <div
        ref={scrollContainerRef}
        className={clsx(containerClassName, 'content-grid-portrait')}
      >
        {titles.map(item => (
          <div className={itemClassName} key={item.id}>
            <TitlePortraitGridItem item={item} />
          </div>
        ))}
      </div> */}
    </div>
  );
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
